<template>
  <div
    class="flex flex-col items-center justify-center h-full pt-12 tmsk-sky-blue-bg"
  >
    <div
      class="flex flex-col items-center justify-center w-full h-full mx-auto space-y-6 sm:flex-row max-w-7xl sm:space-y-0 sm:space-x-6"
    >
      <div class="max-w-2xl space-y-3 text-center">
        <p class="text-3xl font-extrabold tmsk-blue-text">OOPS!</p>
        <p class="text-3xl font-extrabold tmsk-blue-text">Error 404</p>
        <p class="text-xl tmsk-blue-text">The page could not be found.</p>
      </div>
      <img src="@/assets/img/oops.png" class="h-60 sm:h-128" />
    </div>
    <button
      class="w-64 p-2 mt-6 text-sm text-white border border-transparent rounded-full shadow-sm tmsk-blue-bg focus:border-teal-700 focus:shadow-outline-teal focus:outline-none"
      @click="$router.push({ name: 'Home', query: $route.query })"
    >
      Proceed to Homepage
    </button>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  metaInfo () {
    return {
      title: 'StayMasked',
      // meta: [
      //   { property: 'og:title', content: 'StayMasked' },
      //   { property: 'og:url', content: window.location.href },
      //   { property: 'og:site_name', content: 'StayMasked' },
      //   { property: 'og:image', content: 'https://s3-ap-southeast-1.amazonaws.com/mask.stayprepared.sg/assets/staymasked-og-01.jpg' }
      // ],
      link: [
        { rel: 'canonical', href: window.location.href }
      ]
    }
  },
  components: {},
  mixins: [],
  props: {},
  data () {
    return {}
  },
  computed: {},
  watch: {},

  // Lifecycle Hooks
  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {
    // setTimeout(() => this.$router.push({ name: 'Home' }), 5000)
  },
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  methods: {}
}
</script>

<style scoped>
.abs-center {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
</style>
